export const data = function () {
  return {
    dialogIndicadores: false,
    showComprovante: false,
    showComprovanteLaudo: false,
    showComprovanteAgendamento: false,
    page: {
      title: 'Relatório de Cotas Região',
    },
    breadcrumbs: [
      {
        text: 'Relatórios',
        disabled: false,
      },
      {
        text: 'Relatório de Cotas Região',
        disabled: false,
      },
    ],
  }
}
